import { usePlatform, type PlatformType } from '../hooks/usePlatform';
import { Button } from '@/shared/components/ui/Button';
import { useNavigate } from '@tanstack/react-router';
import { Monitor, Smartphone } from 'lucide-react';
import { useTranslation } from 'react-i18next';

type PlatformRestrictionProps = {
  notAllowedPlatforms: PlatformType[];
  children: React.ReactNode;
};

export const PlatformRestriction = ({
  notAllowedPlatforms,
  children,
}: PlatformRestrictionProps) => {
  const platform = usePlatform();
  const navigate = useNavigate();
  const { t } = useTranslation('common');

  if (notAllowedPlatforms?.includes(platform)) {
    const Icon = platform === 'mobile' ? Monitor : Smartphone;
    const targetPlatform = platform === 'mobile' ? 'desktop' : 'mobile';

    return (
      <div className="flex flex-col items-center justify-center h-full min-h-[400px] gap-6 p-8">
        <Icon className="h-16 w-16 text-muted-foreground" />
        <div className="text-center space-y-2">
          <h2 className="text-2xl font-semibold">
            {t(`platformRestriction.${targetPlatform}Only`)}
          </h2>
          <p className="text-muted-foreground">
            {t('platformRestriction.switchTo', { platform: targetPlatform })}
          </p>
        </div>
        <Button onClick={() => navigate({ to: '/' })}>
          {t('platformRestriction.returnHome')}
        </Button>
      </div>
    );
  }

  return children;
};
